import React, { FC } from 'react';

import ReactTooltip from 'react-tooltip';
import { formatPatent } from 'global/utils/plate/patente';
import clsx from 'clsx';
import { DocumentsIcon, PoliceIcon } from 'common/icons';
import { FileDetails } from 'pages/vehicle-documents/components/views/desktop/file-details';
import { DocumentsList } from 'pages/vehicle-documents/components/views/mobile/documents-list';
import { ViewsProps } from '../views.types';

import styles from './styles.module.scss';

export const TabletView: FC<ViewsProps> = ({ detailInfo, isVehicularCheckPoint, onNavigate }) => {
  const tooltip = isVehicularCheckPoint ? 'Documentos del vehículo' : 'Control Vehicular';
  const title = isVehicularCheckPoint ? 'Control Vehicular' : 'Documentos del vehículo';

  return (
    <>
      <ReactTooltip
        backgroundColor="white"
        border
        borderColor="var(--primary)"
        effect="solid"
        id="copyTooltip"
        textColor="var(--primary)"
        type="info">
        {tooltip}
      </ReactTooltip>

      <div className="flex flex-col h-full w-full overflow-hidden">
        <div className="pb-2 flex justify-between items-center">
          <p className="text-primary text-lg">
            {`${title} PPU: ${formatPatent(detailInfo?.vehiculo?.patente) || '-'}`}
          </p>
          <div
            className={clsx(
              'w-7 h-7 bg-primary rounded-md flex justify-center items-center',
              styles.navigateActionContainer,
            )}
            onClick={onNavigate}>
            {isVehicularCheckPoint ? (
              <DocumentsIcon className="cursor-pointer" data-for="copyTooltip" data-tip stroke="white" />
            ) : (
              <PoliceIcon className="cursor-pointer" data-for="copyTooltip" data-tip stroke="white" />
            )}
          </div>
        </div>
        <main className={clsx('h-full w-full flex-1 flex-auto grid gap-3', styles.body)}>
          <FileDetails detailInfo={detailInfo} isVehicularCheckPoint={isVehicularCheckPoint} />
          <div className="flex flex-col w-full h-full min-h-0">
            <div className="p-4 bg-gray-50 flex justify-between items-center uppercase">
              DOCUMENTOS ({detailInfo?.documents?.length || 0})
            </div>
            <DocumentsList className={styles.documents} documents={detailInfo?.documents} />
          </div>
        </main>
      </div>
    </>
  );
};
